module.exports = __webpack_public_path__ + "img/icon-vkadblogger.6e91441b.svg";